"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpareLiveStreaming = exports.useConcurrentStatistics = exports.useMemberInfo = exports.getMembersByIds = exports.postAttachment = exports.postFile = void 0;
const account_1 = require("../../features/base/account");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
// (파일) 파일 업로드
const postFile = async (files) => {
    const url = `/api/mimac/file`; // API 엔드포인트 생성
    const formData = new FormData();
    files.map(file => formData.append('file', file));
    const options = {
        method: 'POST',
        body: formData,
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postFile = postFile;
// (파일) 파일 업로드
const postAttachment = async (file, filepath) => {
    const url = `/api/mimac/file`; // API 엔드포인트 생성
    const formData = new FormData();
    formData.append('file', file); // Add the file
    formData.append('filepath', filepath); // Add the filepath
    const options = {
        method: 'POST',
        body: formData,
    };
    return (0, functions_1.fetchData)(url, options);
};
exports.postAttachment = postAttachment;
// (사용자) 멤버 정보 가져오기
const getMemberList = async (queryString) => {
    const url = `/api/mimac/v1/members?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (사용자) 멤버 id 배열로 조회 — 이름만 오는 응답(다시보기 allowed_viewers 등)에 아이디(identifier)를 보충할 때 사용
const getMembersByIds = async (ids, class_id) => {
    if (!ids || ids.length === 0)
        return [];
    const queryString = (0, functions_1.objectToQueryString)({ id: ids, ...(class_id ? { class_id } : {}) });
    const response = await (0, functions_1.fetchData)(`/api/mimac/v1/members?${queryString}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
    return (response?.result?.items ?? []);
};
exports.getMembersByIds = getMembersByIds;
// (사용자) 멤버 정보 가져오기 -useMemberInfo
const useMemberInfo = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // data를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)([`memberList_${data}`, data], () => getMemberList(queryString));
};
exports.useMemberInfo = useMemberInfo;
// (사용자) 접속 통계 가져오기
const getConcurrentStatistics = async (queryString) => {
    const url = `/api/mimac/v1/members/concurrent?${queryString}`; // 실제 엔드포인트로 변경
    return (0, functions_1.fetchData)(url);
};
const useConcurrentStatistics = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // data를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)(['concurrentStatistics', data], () => getConcurrentStatistics(queryString));
};
exports.useConcurrentStatistics = useConcurrentStatistics;
// 예비 라이브 스트리밍 조회
const getSpareLiveStreaming = async (classId) => {
    const url = `/api/mimac/v1/class/${classId}/live`; // 실제 엔드포인트로 변경
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
const useSpareLiveStreaming = (classId) => {
    return (0, functions_1.useCustomQuery)(['spareLiveStreaming', classId], () => getSpareLiveStreaming(classId ?? ''));
};
exports.useSpareLiveStreaming = useSpareLiveStreaming;
